import axios from 'axios'
import qs from 'qs'
import md5 from 'js-md5'

const isDev = process.env.VUE_APP_MODE === 'test'

const createSid = () => {
  const d = new Date()
  const add0 = (num) => num < 10 ? '0' + num : num
  const time = [d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds()].map(i => add0(i)).join("")
  const r = parseInt(Math.random() * 89999 + 10000)
  const rr = parseInt(Math.random() * 89999 + 10000)
  return 'fourierweb' + time + r + rr
}

axios.interceptors.request.use(function (config) {
  if (config.url.indexOf("japi.233.com") > -1) {
    const { method, data, url } = config
    const params = method === "post" ? (data ? JSON.stringify(data) : '') : (url.indexOf("?") > -1 ? url.slice(url.indexOf("?") + 1, url.length) : "")
    const sid = createSid()
    config.headers['sid'] = sid
    config.headers['sign'] = Object.prototype.toString.call(data) == '[object FormData]' ? md5("RZRRNN9RXYCP" + sid).toUpperCase() : md5("RZRRNN9RXYCP" + sid + params).toUpperCase()
  } else {
    let token = localStorage.getItem("usertoken")
    var host = window.location.host

    // host = "gj.rrxue.cn"
    // host = "ks.rrxue.cn"
    // host = "wx.029985.com"
    if (token == undefined) {
      token = ""
      // token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyaWQiOjE0NjQ5NzEyLCJ1c2VybmFtZSI6Ijk2NjQ2MDZhIiwidW5pb25pZCI6IjExOTQzIiwiaXNzdWVyIjoidXNlciIsImF1ZGllbmNlIjoiIn0.iS_KMPWMS5y-ojH3zooMBrOrfnmhqwkknGodWWtB8Lk"
      if (process.env.NODE_ENV === 'development') {
        // host = "wx.029985.com"
        // host = "wx.zezhipx.com"
        host = "gj.rrxue.cn"
        // host = "233.kecenter.cn"
        // host = "wx.jiatujy.com"
        token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyaWQiOjM1MzgzOTEwLCJ1c2VybmFtZSI6Im1vYmlsZV91anRzOTJtIiwidW5pb25pZCI6IjgxNDY3MiIsImlzc3VlciI6InVzZXIiLCJhdWRpZW5jZSI6IiJ9.j76oh5co2fpn1uEM8IABGXqlSNX233FQGylTUcvhXh4"
        // token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyaWQiOjE0NjQ5NzEyLCJ1c2VybmFtZSI6Ijk2NjQ2MDZhIiwidW5pb25pZCI6IjUzNjAzIiwiaXNzdWVyIjoidXNlciIsImF1ZGllbmNlIjoiIn0.kZYaOGayYhOWg-wGv16BavziWVvaKTKje129s-89Kmg"
        // token = ""
    }
    }
    config.params = {
      stamp: new Date().getTime(),
      host: host,
      token: token,
      ...config.params
    }
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

export const uri = isDev ? 'http://192.168.0.164' : 'https://uapi.233.com' 
// export const uri = 'http://192.168.0.164'

export const GetUnionLogoByPromote = (params, callback) => get('/unioninfo/promote/GetUnionLogoByPromote', params, callback)// h5 pc 获取机构logo
export const GetLoginStatus = (params, callback) => get('/UnionInfo/Info/GetLoginStatus', params, callback)// login状态
export const GetCourseClassByHost = (params, callback) => get('/UnionInfo/Promote/GetCourseClassByHost', params, callback)// 入门、习题班推广分类

export const GetClassName = (params, callback) => get('/UnionInfo/Promote/GetClassName', params, callback)// 获取考试分类名
export const GetPromoteCourse = (params, callback) => get('/UnionInfo/Promote/GetPromoteCourse', params, callback)// 获取推广的习题班、 入门版

export const GetCourseDetail = (params, callback) => get('/UnionInfo/Promote/GetCourseDetail', params, callback)// 入门班课程查看详情
export const GetMyclassChapterAndNode = (params, callback) => get('/UnionInfo/Promote/GetMyclassChapterAndNode', params, callback)// 返回当前课程的章节目录
export const GetAskAnswerByMyclassIdList = (params, callback) => get('/member/AskAnswer/GetAskAnswerByMyclassIdList', params, callback)// 详情答疑


export const LoginInfoByPromote = (params, callback) => get('/UnionInfo/Promote/LoginInfoByPromote', params, callback)// 判断当前用户是否登录并且绑定手机
export const LingKeByIsLogin = (params, callback) => get('/UnionInfo/Promote/LingKeByIsLogin', params, callback)// 已经登录，且绑定了手机的学员领课
export const LingKe = (params, callback) => get('/UnionInfo/Promote/LingKe', params, callback)// 领课操作

export const GetPromoteLeadInfo = (params, callback) => get('/UnionInfo/Promote/GetPromoteLeadInfo', params, callback)// 学生前端领课成功之后获取引导加群
export const GetMoreCourse = (params, callback) => get('/UnionInfo/Promote/GetMoreCourse', params, callback)// 推广获取更多课程
export const GetSeniorFlagByPromote = (params, callback) => get('/unioninfo/promote/GetSeniorFlagByPromote', params, callback)// 判断高级普通平台

export const GetUnionPermission = (params, callback) => get('/Course/Course/GetUnionPermission', params, callback)// 判断联盟权限
export const GetNewStudentRedPack = (params, callback) => get('/UnionInfo/Promote/GetNewStudentRedPack', params, callback)// 获取新人注册红包
// export const addSubNum = (params, callback) => post('/Live/Live/addSubNum', params, callback)

export const smsCaptcha = (params, callback) => axios.post("https://japi.233.com/ess-ucs-api/basic/do/smsCaptcha", params, { headers: { "Content-Type":"application/json" }})
.then(res => {
  callback(res.data)
})// 手机验证码

export const get = (api, params, callback) => axios.get(uri + api, {
  params: params
}).then(res => {
  callback(res.data)
})

export const post = (api, params, callback) => axios.post(uri + api, qs.stringify(params))
.then(res => {
  callback(res.data)
})
// leadInfo  {"currentUserName":"lm18774949370","dozDomain":"ks.rrxue.cn","open":1,"password":"123456","myclassid":4814,
// "token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyaWQiOjMxNjQ3NzcyLCJ1c2VybmFtZSI6ImxtMTg3NzQ5NDkzNzAiLCJ1bmlvbmlkIjoiMTE5NDMiLCJpc3N1ZXIiOiJ1c2VyIiwiYXVkaWVuY2UiOiIifQ.rzLpDpYEA_tg0gCh2pjTWJqaM_N8zQ0eZ7eTkblohWg"}